module.exports = __webpack_public_path__ + "img/626180d.png";